import React from 'react';
import { TextField, MenuItem, Stack } from '@mui/material';

const TableFilterControls = ({
  searchValue,
  onSearchChange,
  statusValue,
  onStatusChange,
  statusLabel = "Statut",  
  statusOptions = [        
    { value: '', label: 'Tous' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' }
  ],
  hideSearch = false 
}) => {
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      {!hideSearch && (
        <TextField
          variant="outlined"
          size="small"
          placeholder="Rechercher"
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      )}
      <TextField
        select
        label={statusLabel}
        size="small"
        value={statusValue}
        onChange={(e) => onStatusChange(e.target.value)}
        style={{ minWidth: 140 }}
      >
        {statusOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  );
};

export default TableFilterControls;
